import GenericRequest, { METHOD_PUT } from '../../shared/webservices/GenericRequest';
import RouterUtils from '../../shared/routing/RouterUtils';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class CompanyAssociationAdd extends GenericRequest {

    document_schema_id;
    document_schema_monthly_id;

    constructor(nif, documentSchemaId, documentSchemaMonthlyId) {
        super(METHOD_PUT, RouterUtils.generateRoute(ApiEndpoints.COMPANY_ASSOCIATION_ADD, { nif }));

        this.document_schema_id = documentSchemaId;
        this.document_schema_monthly_id = documentSchemaMonthlyId;
    }

    overrideRequest() {
        const request = {};
        if ( this.document_schema_id ) request.document_schema_id = this.document_schema_id;
        if ( this.document_schema_monthly_id ) request.document_schema_monthly_id = this.document_schema_monthly_id;
        return request;
    }

}



// WEBPACK FOOTER //
// ./src/app/outsource/ws/CompanyAssociationAdd.js